import { useEffect, useState } from 'react'
import { BRIDGE } from 'core/constants/bridge'
import { THEME_TYPE } from 'core/constants'
import { TypeTheme } from 'core/style/theme'
import { setChangedTheme } from 'core/singleton'

/**  브릿지 함수 추가용 hooks
 * dispatchEvent(window.flexCollectThemeTypeB)
 * dispatchEvent(window.flexCollectThemeTypeA)
 */
export default function useSetThemeEventListener({
  theme,
  themeB,
}: {
  theme: TypeTheme
  themeB: TypeTheme
}) {
  const [themeType, setThemeType] = useState<THEME_TYPE>(THEME_TYPE.DEFAULT)

  useEffect(() => {
    window[BRIDGE.THEME_TYPE_A] = new CustomEvent(BRIDGE.THEME_TYPE_A)
    window[BRIDGE.THEME_TYPE_B] = new CustomEvent(BRIDGE.THEME_TYPE_B)

    const handleSetThemeTypeA = () => {
      setChangedTheme(THEME_TYPE.DEFAULT)
      if (window[BRIDGE.THEME_TYPE_A]) {
        setThemeType(THEME_TYPE.DEFAULT)
      }
    }

    const handleSetThemeTypeB = () => {
      setChangedTheme(THEME_TYPE.TYPE_B)
      if (window[BRIDGE.THEME_TYPE_B]) {
        setThemeType(THEME_TYPE.TYPE_B)
      }
    }

    window.addEventListener(BRIDGE.THEME_TYPE_A, handleSetThemeTypeA)
    window.addEventListener(BRIDGE.THEME_TYPE_B, handleSetThemeTypeB)

    return () => {
      window.removeEventListener([BRIDGE.THEME_TYPE_A], handleSetThemeTypeA)
      window.removeEventListener([BRIDGE.THEME_TYPE_B], handleSetThemeTypeB)
    }
  }, [])

  const themes = {
    [THEME_TYPE.DEFAULT]: theme, // 기본 테마 객체
    [THEME_TYPE.TYPE_B]: themeB, // 타입B 테마 객체
  }

  return themes[themeType]
}
